module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4300.7aaf013f.png";